import React, { FC } from 'react';
import {
  Card,
  CardContent
} from '@fcpartners/uikit-v2/components/ui/card';
import { Skeleton } from '@fcpartners/uikit-v2/components/ui/skeleton';

type TCardListSkeletonProps = {
  count?: number;
  showImage?: boolean;
  fieldsCount?: number;
  className?: string;
};

const CardListSkeleton: FC<TCardListSkeletonProps> = ({
  count = 3,
  showImage = true,
  fieldsCount = 8,
  className = ''
}) => {
  return (
    <div className={`mt-4 ${className}`}>
      {Array.from({ length: count }).map((_, index) => (
        <Card
          className="w-full bg-card shadow-none py-2 mb-2"
          key={index}
        >
          <CardContent>
            <div className="flex gap-2 mb-4">
              {showImage && (
                <div className="flex-none">
                  <Skeleton className="w-20 h-20 rounded-md" />
                </div>
              )}
              <div className="flex-grow flex flex-col gap-2">
                <Skeleton className="h-6 w-1/3" />
                <div className="grid grid-cols-2 gap-2 md:grid-cols-4 lg:grid-cols-8 mt-2">
                  {Array.from({ length: fieldsCount }).map((_, fieldIndex) => (
                    <div key={fieldIndex} className="flex flex-col gap-1">
                      <Skeleton className="h-4 w-16" />
                      <Skeleton className="h-5 w-20" />
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex-none">
                <Skeleton className="h-10 w-32 rounded-md" />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default CardListSkeleton;
